/**
 * Created by Carsten Bühler
 * User: CBuehler on 09.11.2015
 * Copyright: xdot GmbH 2015
 */


import { ApiUtil } from 'plugin/liferay-widgets-react-web';
import { Client } from 'external/lwr-client';

const baseServiceWithContext = (m, o, c) => Client.invokeWithContext('/base.groupschema/' + m, o, c);
const adminServiceWithContext = (m, o, c) => Client.invokeWithContext('/administration.administrationapi/' + m, o, c);
//const baseService = (m, o) => Client.invoke('/base.groupschema/' + m, o);
//const adminService = (m, o) => Client.invoke('/administration.administrationapi/' + m, o);

const api = {

    listGroupSchemas(query){
        return baseServiceWithContext('list-group-schemas.1', {});
    },

    addManualBooleanState(query) {
        return adminServiceWithContext('add-manual-boolean-state.3', {
            title: query.title,
            groupId: query.groupId
        }, {});
    }

};

ApiUtil.namedApi('GroupSchemaWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/GroupSchemaWebApi.js